import styled from "styled-components";

// Usa transient props ($) para evitar que se filtren al DOM
export const TecladoAlfanumericoContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  .hg-button {
    height: 60px;
    border-bottom: 0 !important;
  }

  ${({ $modeLight }) =>
    $modeLight &&
    ` .hg-theme-default{
    background-color: var(--color-latex10);
  }`}

  /* BOTONES BASE (alfanuméricos) */
  .hg-white {
    background-color: var(--color-white);
    color: var(--color-latex10);
  }
  .hg-white:active {
    background-color: var(--color-grey65);
  }
  .hg-latex10 {
    background-color: var(--color-latex10);
    color: var(--color-white);
  }
  .hg-latex10:active {
    background-color: var(--color-white);
    color: var(--color-latex10);
  }

  /* BORRAR: siempre rojo */
  .hg-button.hg-danger {
    background-color: var(--color-danger) !important;
    width: ${({ $sinNumeros }) => ($sinNumeros ? "20px" : "84px")};
    color: var(--color-white) !important;
  }
  .hg-button.hg-danger:active {
    background-color: var(--color-white) !important;
    color: var(--color-latex10) !important;
  }

  /* ENTER: siempre verde */
  .hg-button.hg-broccoli {
    background-color: var(--color-broccoli) !important;
    width: ${({ $sinNumeros }) => ($sinNumeros ? "90px" : "84px")};
    color: var(--color-white) !important;
  }
  .hg-button.hg-broccoli:active {
    background-color: var(--color-white) !important;
    color: var(--color-latex10) !important;
  }

  /* ESPACIO: depende del modo, como en legacy */
  .hg-button.hg-space {
    background-color: ${({ $modeLight }) =>
      $modeLight ? "var(--color-white)" : "var(--color-latex10)"} !important;
    width: ${({ $sinNumeros }) => ($sinNumeros ? "88px" : "148px")};
    color: ${({ $modeLight }) =>
      $modeLight ? "var(--color-latex10)" : "var(--color-white)"} !important;
  }
  .hg-button.hg-space:active {
    background-color: ${({ $modeLight }) =>
      $modeLight ? "var(--color-grey65)" : "var(--color-white)"} !important;
    color: var(--color-latex10) !important;
  }

  .hg-empty {
    background-color: ${({ $modeLight }) =>
      $modeLight ? "var(--color-white)" : "var(--color-latex10)"};
  }
`;
